import Banner from "components/common/Banner";
import OverlayMobile from "./OverlayMobile";
import Overlay from "./Overlay";

import envs from "config/envs";

const BannerCnpAssurance = () => {
  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_whoweare.webp`}
        width="100vw"
        height="45vw"
      >
        <Banner.Overlay center={false}>
          <Overlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_whoweare_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <OverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};

export default BannerCnpAssurance;
